import { sendApiRequest, shouldGetCourseDataFromCanvasAPIs } from '../lib/helper';
import { IAssignment } from "../types/IAssignment";
import { IAuthenticationStatusContext } from "../types/IAuthenticationStatusContext";
import { ICourse, ISemester } from "../types/ICourse";

export const getKeplerSyllabus = async (course: ICourse) => {
    return sendApiRequest(`/api/canvas/getKeplerSyllabus?courseId=${course.CanvasId}`, "GET");
}

export const getAssignments = async (course: ICourse, authContext: IAuthenticationStatusContext): Promise<IAssignment[]> => {

    const semester: ISemester = {
        Semester: course.Semester,
        Year: course.Year
    }

    let shouldGetDataFromCanvas = false;
    try
    {
        shouldGetDataFromCanvas = (await shouldGetCourseDataFromCanvasAPIs(semester, authContext) || false) && course.CanvasId !== undefined;
    }
    catch(err)
    {
        console.log(err);
    }
    if(shouldGetDataFromCanvas)
    {
        return sendApiRequest(`/api/canvas/getAssignmentsFromCanvas?courseId=${course.CanvasId}`, "GET").then(res => {
            if(typeof res === "object")
            {
                let retVal = res.map((a: any) => {
                 
                    const retVal: IAssignment = {
                        AssignmentId: a.id,
                        Path: `${course.BlobFolderName}/${a.name}`,
                        Name: a.name,
                        Created: a.created_at,
                        Description: a.description,
                        Course: course
                    };
                    return retVal;
                }).sort((a: IAssignment,b: IAssignment) => a.Name < b.Name ? -1 : 1);
                if(authContext.CanvasAuthStatus)
                {
                    sendApiRequest(`/api/blobStorage/ensureCourseFileInBlobStorage`, "POST", JSON.stringify({course: course})).then(res => {
                        console.log("Successfully updated the courses.txt file");
                    }).catch(err => {
                        console.log("Unable to update the courses.txt file", err);
                    });
                }
                return retVal;
            }
            else
            {
                throw new Error(res);
            }
        });
    }
    else
    {
        return sendApiRequest("/api/blobStorage/getAssignmentsFromBlobStorage", "POST", JSON.stringify({course: course}));
    }
};
